import React, { useEffect, useRef, useState } from 'react'
import { IconButton, ScreenReaderOnly } from '@moonpig/launchpad-components'
import { IconSystemSend } from '@moonpig/launchpad-assets'
import { useLocaleText } from '../locale'
import { useChatGatewayContext, useChatMessagesContext } from '../ChatContext'
import { StyledForm, StyledFormContainer, StyledTextInput } from './styled'
import { ConnectionStatus } from '../hooks/types'
import {
  createGenericSelectContentEvent,
  trackGAEvent,
} from '@moonpig/web-core-analytics'
import { useIsMobile } from '@moonpig/web-shared-utils'

export const ChatInput = () => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [value, setValue] = useState('')
  const { connectionStatus, sendMessage } = useChatGatewayContext()
  const { addUserMessage } = useChatMessagesContext()

  const t = useLocaleText()
  const isInputDisabled =
    connectionStatus === ConnectionStatus.Sending ||
    connectionStatus === ConnectionStatus.Disconnected
  const INPUT_VALUE_MAX_CHAT_LENGTH = 1000

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }
  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!value.trim()) return

    addUserMessage(value)
    sendMessage(value)
    setValue('')

    trackGAEvent(
      createGenericSelectContentEvent({
        eventCategory: 'ai concierge',
        eventAction: 'submit question',
        eventLabel: 'free text form submit',
      }),
    )
  }

  const isMobile = useIsMobile()

  useEffect(() => {
    if (!isMobile && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isMobile])

  return (
    <StyledFormContainer>
      <StyledForm onSubmit={handleFormSubmit}>
        <ScreenReaderOnly as="label" htmlFor="message" id="chat-input-label">
          {t('concierge_chat.input_label')}
        </ScreenReaderOnly>
        <StyledTextInput
          ref={inputRef}
          data-testid={'search-concierge-modal-input-text'}
          ariaLabelledBy="chat-input-label"
          placeholder={t('concierge_chat.input_placeholder')}
          autoComplete="off"
          name="message"
          value={value}
          onChange={handleChange}
          componentEndTestId="search-concierge-modal-input-submit"
          maxLength={INPUT_VALUE_MAX_CHAT_LENGTH}
          hideMaxLengthIndicator
          componentEnd={
            <IconButton
              disabled={isInputDisabled}
              icon={IconSystemSend}
              label={t('concierge_chat.input_submit_label')}
              type="submit"
            />
          }
        />
      </StyledForm>
    </StyledFormContainer>
  )
}
